/*global FB */
/*global openFB */
/*global CryptoJS */
//import { AesUtil } from '../JS/AesUtil'

import React, { Component } from 'react';
import './App.css';
import {
  HashRouter,
  Redirect
} from "react-router-dom";
// import '../styles/css/normalize.css';
// import '../styles/css/bootstrap.css';
// import '../styles/css/font-awesome.css';
// import '../styles/css/default.css'
// import '../theme/default_theme.css'
import propTypes from 'prop-types';
import { router } from '../routes/index'
import SidePanel from './side-panel/sidePanel'
import Popup from '../UI/popup/popup'
import {
  roomAssistanceStatusChange,
  getClientConfig,
  getWetherInfo,
  updateCurrentLayout,
  updateDurationLang,
  updateDefaultLanguage,
  setFaceData,
  fetchFaceBasedJson,
  DefaultFaceData,
  facebookProfile,
  setNavItem,
  setLauncherWidget,
  setRegPage,
  allColors,
  firstOnHome,
  setTVtype,
  HealthService,
  setPreloadScreen,
  popupOpenClose,
  setDoorKeyNotificaionPage
} from '../action/action'
import {
  guestLanguage,
  guestDetails,
  getHotelLanguages,
  getServerTime,
  fetchSissonToken
} from '../action/homeAction'
import {
  fetchActivities,
} from '../action/activityAction'
import { mapComponentToNavItem } from '../components/shared/mapNavItem'
import { connect } from 'react-redux'
import RoomAssistance from './room-assistance/roomAssistance'
import img from '../images/bg_002.jpeg'
import { CMSPath, compType, bluetoothCheckMsg,serviceFailureMsg } from '../config/constant'
import BrowserPopup from '../components/browser-popup/browserPopup'
import VideoPlayer from '../UI/video-player/videoPlayer'
import NIHPopup from '../UI/new-popup/NIHPopup'
import LogoutPopup from './logout-popup/logoutPopup'
import ConfromPage from '../UI/confromPage/conformPage'
import { languageSelector } from './shared/languageSelector'
import {
  getCurrentSchedule,
  getLayout,
  hashCode
} from './shared/layoutSelector'
import { fetchSessionToken } from '../JS/fetchSessionToken'
import LaodingMass from '../UI/loadingMass/loadingMass'
import AdminDeviceRegistration from '../components/admin-device-registration/adminDeviceRegistration';
import GuestDeviceReg from '../components/guest-device-registration/guestDeviceReg';
import ConformationPage from '../components/admin-device-registration/conformationPage';
import TVConformPage from '../components/tv-channels/conformPage'
import { setColor } from '../JS/setColors'
import { checkStatus } from '../components/shared/facebookOauth'
import OrderDetail from '../components/HCommerce/orderDetail'
import GuestLoginPopup from '../UI/GuestLoginPopup/guestLoginPopup'
import SubmitGuestRequest from '../components/guestRequest/submitGuestRequest'
import Preload from '../UI/preLoad/preload'
import { wipeGuestData } from '../JS/wipeGuestData'
import { fetchLayoutType } from '../JS/fetchLayoutType'
import {copy_to_tempstorage_if_exists} from '../layout2.0/JS/utility';

import '../styles/css/normalize.css';
// import './styles/bootstrap.scss';
//import '../styles/css/bootstrap.css';
//import './styles/default.scss';
// import '../styles/css/font-awesome.css';
// import '../styles/css/default.css'
import '../JS/heightFix'
// import '../theme/theme.css'
// import '../theme/default_theme.css'

//------door key feature imports
import DoorKey from '../UI/doorKey/doorKey'
import DoorNotification from '../UI/doorKey/DoorNotification'
import DoorErrorPopup from '../UI/doorKey/errorPop'
import '../styles/css/all.min.css'
import LoginPopUp from '../UI/doorKey/loginPopUp'
import QRScannerPage from '../UI/doorKey/QRScannerPage'
import { getCiphertext } from '../JS/getCipherText'

window.checkKeyPageOpen = (key) => {
  try {
    if (window.AppCompRef)
      window.AppCompRef.checkAssaAbloy(key);
    else
      console.log("AppCompRef error")
  } catch (e) {
    console.log("error while tring to call js function from Native:", e);
  }
}

console.log("App");
class App extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.timeoutTimer = null;
    this.state = {
      currentLayout: {},
      currentLang: "",
      tokenAvailable: false
    }
    window.AppCompRef = this
  }

  checkAssaAbloy = () => {
    console.log("checkKeyPageOpen called");
    if (this.props.showDoorKeyPage) {
      if (window.android) {
        if (window.android.isNetworkEnabled() && window.android.isBluetoothEnabled()) {
          window.android.openLock();
        } else {
          this.props.popupOpenClose(true, bluetoothCheckMsg);
          console.log("network issue.")
        }
      } else if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
        window.cordova.plugins.AssaAbloy.isNetworkEnabled(
          "hello", this.onNetworkSuc, this.onError
        )
      }
    }
  }

  onNetworkSuc = () => {
    window.cordova.plugins.AssaAbloy.isBluetoothEnabled(
      "hello", this.onBluetoothSuc, this.onError
    )
  }

  onBluetoothSuc = () => {
    window.cordova.plugins.AssaAbloy.openLock(
      "hello",
      () => { console.log("openLock success") },
      () => { console.log("openLock failed") }
    );
  }

  onError = () => {
    this.props.popupOpenClose(true, bluetoothCheckMsg);
    console.log("network issue.")
  }

  static getDerivedStateFromProps(props, state) {
    let currentHash
    let storedHash = sessionStorage.getItem("hashForLayout");
    let currentLayout, codeToHash, schedule, curLangStr;
    curLangStr = languageSelector(props);
    if (props.faceData) {
      if (props.schedules) {
        schedule = {
          schedules: props.schedules["en"],
          language: "en"
        }
        // console.log("schedules schedule", schedule);
      } else {
        schedule = {
          schedules: props.defaultLayouts["en"],
          language: "en"
        }
        //console.log("default schedule", props.schedules, schedule);
      }
    } else {
      schedule = getCurrentSchedule(props);
      //console.log("schedule", schedule);
    }
    /*
    if (props.durationLang && schedule.language && props.durationLang !== schedule.language) {
      console.log("props.guestLanguages , schedule.language", props.durationLang, schedule.language)
      alert(props.layoutText.alertText);
    }
    */
    currentLayout = getLayout(props, schedule);
    codeToHash = JSON.stringify(currentLayout);
    currentHash = codeToHash ? hashCode(codeToHash) : 0
    sessionStorage.setItem("hashForLayout", currentHash);
    //console.log("current Layout", currentLayout)
    if (currentLayout && props.durationId !== currentLayout.durationId
      && currentHash !== storedHash) {
      //console.log("Hash", currentHash);
      fetchLayoutType(currentLayout);
      props.updateCurrentLayout(currentLayout, schedule.language, curLangStr);
      if (currentLayout.brandingInfo) {
        let weatherColor, menuColor;
        if (currentLayout.brandingInfo && currentLayout.brandingInfo.app
          && currentLayout.brandingInfo.app.menuWidget) {
          menuColor = currentLayout.brandingInfo.app.menuWidget;
        }
        setColor(menuColor);
        props.allColors(menuColor);
      }
      mapComponentToNavItem(props, currentLayout.scrollableWidgets.widgets, compType);
      props.fetchActivities(currentLayout.scrollableWidgets.widgets);
    } else if (props.durationLang && schedule.language && props.durationLang !== schedule.language) {
      props.updateDurationLang(schedule.language);
    }
    // if (props.firstTimeOnHome < 2) {
    //   console.log("new state", props.firstTimeOnHome);
    //   props.firstOnHome(props.firstTimeOnHome + 1);
    //   setColor(props.menuColor);
    // }
    if (props.menuColor && props.menuColor.assetBackgroundColor) {
      //console.log("getDerivedStateFromProps color change");
      setColor(props.menuColor);
    }
    return {
      currentLayout,
      currentLang: props.guestLanguages,
    }
  }

  componentDidUpdate(prevPro) {
    //console.log("componentdid update.", this.props.menuColor)
    let sessionToken = localStorage.getItem('GuestJourneySessionToken');
    let room = localStorage.getItem("room");
    // console.log("guestCheckedOut", prevPro.guestCheckedOut, this.props.guestCheckedOut);
    if (prevPro.guestCheckedOut !== this.props.guestCheckedOut) {
      console.log(sessionToken && room && room !== "null")
      if (sessionToken && room && room !== "null") {
        if (!this.props.guestCheckedOut) {
          console.log("guest is out @@@");
          wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"});
        }
      }
    }
    // if (this.props.durationId !== 0 && this.props.preloadScreen) {
    //   window.setTimeout(() => {
    //     this.props.setPreloadScreen(false);
    //   }, 1000);
    // }
    // window.setTimeout(() => {
    //   setColor(this.props.menuColor);
    // }, 200)
  }

  reciveFaceData = () => {
    setInterval(() => {
      let faceData = null;
      let localFaceData = localStorage.getItem("localFaceData");
      if (typeof window.android !== 'undefined' && window.android !== null) {
        faceData = window.android.myFunc('hello');
        if (faceData) {
          if (!localFaceData) {
            this.props.setFaceData(faceData);
            this.props.fetchFaceBasedJson(faceData, this.deviceConfigCallBack);
            localStorage.setItem("localFaceData", faceData);
          } else if (localFaceData !== faceData) {
            this.props.setFaceData(faceData);
            this.props.fetchFaceBasedJson(faceData, this.deviceConfigCallBack);
            localStorage.setItem("localFaceData", faceData);
          }
        }
      } else {
        console.log('Not in android webbox');
      }
    }, 2000);
  }

  callForLayout = (userData, token) => {
    let room = localStorage.getItem("room");
    let roomID = localStorage.getItem("roomID");
    let date = new Date();
    let birthyear, age;
    let sentJson;
    if (userData && userData.gender && userData.birthday) {
      birthyear = parseInt(userData.birthday.slice(6, 10));
      age = (date.getFullYear()) - birthyear;
      //console.log("user Data", userData, age, userData.gender);
      sentJson = {
        "age": `${age ? age : 42}`,
        "classificationType": "Leisure",
        "gender": `${userData.gender ? userData.gender : "male"}`,
      }
      this.props.fetchFaceBasedJson(JSON.stringify(sentJson), this.deviceConfigCallBack);
    } else if (!room || room === "null") {
      sentJson = {
        "age": `42`,
        "classificationType": "Leisure",
        "gender": `male`,
      }
      this.props.fetchFaceBasedJson(JSON.stringify(sentJson), this.deviceConfigCallBack);
    } else {
      console.log("in else fpr Call for layout.");
      this.props.getClientConfig(token, this.deviceConfigCallBack);
    }
  }

  deviceConfigCallBack = (status) => {
    console.log("got colback", status);
    this.props.setPreloadScreen(false);
    window.clearTimeout(this.timeoutTimer);
    if (!status) {
      this.props.popupOpenClose(true, serviceFailureMsg);
    }
  }
  sessionTokenFlow = () => {
    let encodedData = fetchSessionToken();
    this.props.fetchSissonToken(encodedData, this.apiCalles, this.props.deviceName);
    //console.log("encodedData", encodedData);
  }

  apiCalles = (token) => {
    console.log("apiCalles");
    let userData = localStorage.getItem("FB_user_info");
    userData = JSON.parse(userData);
    this.props.DefaultFaceData();
    this.props.guestLanguage(token);
    this.props.getHotelLanguages(token);
    this.timer = setInterval(() => {
      this.props.getServerTime();
    }, 60000);
    window.setInterval(() => {
      this.props.HealthService(token);
      //console.log("hit health service.")
    }, 180000);
    this.props.HealthService(token);
    this.props.getServerTime();
    this.props.guestDetails(token, wipeGuestData);
    /*setInterval(() => {
      this.callForLayout(userData);
    }, 900000);*/
    this.callForLayout(userData, token);
    this.props.getWetherInfo(token);
  }

  facebookOauthInit = () => {
    if (window.cordova) {
      openFB.init({ appId: '449978942427999' });//daigo->2292736537663885//Inn->449978942427999
    }
    else {
      window.fbAsyncInit = function () {
        FB.init({
          appId: '449978942427999',
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v3.3'//daigo-v3.2//Inn-v3.3
        });

        FB.Canvas.setSize({ height: 420 });
      };
    }
  }



  removeCookies = () => {
    // console.log("remove cookies");
    let cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }
  componentDidMount() {
    //getCiphertext()
    console.log("componentDidMount")
    let sessionToken = localStorage.getItem('GuestJourneySessionToken');
    this.props.updateDefaultLanguage();
    if (sessionToken) {
      this.props.setPreloadScreen(true);
      this.apiCalles(sessionToken);
    } else {
      this.sessionTokenFlow();
    }
    this.timeoutTimer = window.setTimeout(
      () => {
        this.props.setPreloadScreen(false);
        this.props.popupOpenClose(true, serviceFailureMsg);
      }, 10000
    )
    this.facebookOauthInit();
    let img = localStorage.getItem("user_profile");
    this.props.facebookProfile(img);
    /*if (window.cordova && window.device.platform === "Android") {
      this.reciveFaceData();
      setInterval(this.reciveFaceData(), 2000);
    }*/
    if (window.QRScanner) {
      window.QRScanner.prepare(() => {
        console.log("device is ready for scann")
      })
    }
    
    if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
      window.cordova.plugins.AssaAbloy.initializePlugin(
        "Initialize",
        () => { console.log("initializePlugin success") },
        () => { console.log("initializePlugin failed") }
      )
    }

    const profile_photo = localStorage.getItem('profile_photo');
    if(window.device){
      const platform = window.device.platform; 
    if(profile_photo && profile_photo != 'null' && platform != 'Android'){
      copy_to_tempstorage_if_exists('profile_photo.jpg', (uri) => {localStorage.setItem('profile_photo', uri)}, (err) => {console.log('unable to read profile photo'); localStorage.removeItem('profile_photo')});
    }
    }
    
    

  }

  componentWillUnmount() {
    window.clearInterval(this.timer);
  }

  postFb = () => {
    checkStatus('post');
  }

  render() {
    let bgImage = this.props.bgImage;
    //BG Image must be change with layout 
    //console.log("new app render")
    return (
      this.props.QRScanPage ?
        <QRScannerPage /> :
        <div
          className="main container"
          style={
            bgImage ?
              {
                backgroundColor: "rgba(0, 0, 0, 0)",
                backgroundPositionX: "center",
                backgroundPositionY: "top",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "scroll",
                backgroundImage: `url('${CMSPath}${bgImage}')`,
                backgroundSize: "cover",
                backgroundOrigin: "padding-box",
                backgroundClip: "border-box",
                maxWidth: "100%",
              } :
              {
                backgroundColor: "rgba(0, 0, 0, 0)",
                backgroundPositionX: "center",
                backgroundPositionY: "top",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "scroll",
                //backgroundImage: `url('${img}')`,
                backgroundSize: "cover",
                backgroundOrigin: "padding-box",
                backgroundClip: "border-box",
                maxWidth: "100%",
              }}>

          <div className="main columns">
            <SidePanel />
            {
              !this.props.adminDevicePage && !this.props.GuestDevReg && !this.props.currentWidgetOb.path ?
                <HashRouter>
                  <section id="app-body" className="col">
                    <Redirect exact to="/" />
                    {router()}
                  </section>
                </HashRouter> :
                this.props.currentWidgetOb.path ?
                  <HashRouter>
                    <section id="app-body" className="col">
                      <Redirect exact to={`${this.props.currentWidgetOb.path}`} />
                      {router()}
                    </section>
                  </HashRouter>
                  : this.props.adminDevicePage ? <AdminDeviceRegistration /> : <GuestDeviceReg />
            }
          </div>

          {
            this.props.roomAssistancePageStatus ?
              <RoomAssistance />
              : ""
          }
          {
            this.props.browsersListPopup ?
              <BrowserPopup /> : ""
          }
          {
            this.props.callFacebookPopup ?
              <Popup /> : ""
          }
          {
            this.props.videoPlayer ?
              <VideoPlayer /> : ""
          }
          {
            this.props.notInHotelPopup ?
              <NIHPopup /> : ""
          }
          {
            this.props.fbLogoutPopup ?
              <LogoutPopup /> : ""

          }
          {
            this.props.LaodingMass ?
              <LaodingMass /> : ""
          }
          {
            this.props.conformationPage ?
              <ConformationPage /> : ""
          }
          {
            this.props.confromPage ?
              <ConfromPage /> : ""
          }
          {
            this.props.tvConformPage ?
              <TVConformPage /> : ""
          }
          {
            this.props.orderDetailPage ?
              <OrderDetail /> : ""
          }
          {
            this.props.guestLoginPage ?
              <GuestLoginPopup /> : ""
          }
          {
            this.props.showGuestRequestSubmitPage ?
              <SubmitGuestRequest /> : ""
          }
          {
            this.props.preloadScreen ?
              <Preload /> : null
          }
          {
            this.props.showDoorKeyPage ?
              <DoorNotification /> : null
          }
          {this.props.doorLogin ?
            <LoginPopUp /> : null

          }
          {
            this.props.errorPopUP ?
              <DoorErrorPopup /> : null
          }
          <DoorKey />
        </div>
    );
  }
}

//export default App;
const mapStateToProps = state => {
  return {
    sessionToken: state.store.sessionToken,
    roomAssistancePageStatus: state.store.roomAssistance.popupStatus,
    bgImage: state.store.home.currentDuration.launcherBgImageUrl,
    scrollWid: state.store.home.currentDuration.scrollableWidgets ?
      state.store.home.currentDuration.scrollableWidgets.widgets : [],
    browsersListPopup: state.store.browserListPopup.showPopup,
    clientConfig: state.store.home.clientConfig.webAppWidgetsInfo,
    schedules: state.store.home.clientConfig.webAppWidgetsInfo ?
      state.store.home.clientConfig.webAppWidgetsInfo.schedules : {},
    durations: state.store.home.clientConfig.webAppWidgetsInfo ?
      state.store.home.clientConfig.webAppWidgetsInfo.durations : [],
    defaultLayouts: state.store.home.clientConfig.webAppWidgetsInfo ?
      state.store.home.clientConfig.webAppWidgetsInfo.defaultLayout : {},
    MasterWidget: state.store.home.clientConfig.webAppWidgetsInfo ?
      state.store.home.clientConfig.webAppWidgetsInfo.widgetsMaster : {},
    serverTime: state.store.home.serverTimeDate.time,
    guestDetail: state.store.home.guestDetails,
    guestLanguages: state.store.home.guestLanguage.preferredLanguageCode,
    hotelLanguage: state.store.home.hotelLanguages,
    durationId: state.store.home.currentDuration.durationId ?
      state.store.home.currentDuration.durationId : 0,
    layoutText: state.store.home.stringConst,
    durationLang: state.store.home.durationLang,
    faceData: state.store.faceData,
    callFacebookPopup: state.store.callFacebookPopup,
    videoPlayer: state.store.movies.videoPlayer,
    notInHotelPopup: state.store.notInHotelPopup,
    fbLogoutPopup: state.store.logout.status,
    LaodingMass: state.store.LaodingMass,
    adminDevicePage: state.store.adminDevicePage,
    conformationPage: state.store.deviceReg.conformationPage,
    appLauncherWidget: state.store.appLauncher.widget,
    GuestDevReg: state.store.deviceReg.guestRegPag,
    deviceName: state.store.deviceReg.deviceName,
    brandingInfo: state.store.home.currentDuration.brandingInfo.app,
    firstTimeOnHome: state.store.home.firstTimeOnHome,
    menuColor: state.store.home.MenuColor,
    confromPage: state.store.confromPage,
    tvConformPage: state.store.tvChannels.conformPage,
    orderDetailPage: state.store.Hcommerce.orderDetailPage,
    guestCheckedOut: state.store.guestCheckedOut,
    guestLoginPage: state.store.guestLoginPage,
    showGuestRequestSubmitPage: state.store.guestRequest.showGuestRequestSubmitPage,
    preloadScreen: state.store.preloadScreen,
    currentWidgetOb: state.store.sideNavBar.currentWidget,
    showDoorKeyPage: state.store.doorKey.showDoorKeyPage,
    doorLogin: state.store.doorKey.doorLogin,
    QRScanPage: state.store.QRScannerPage,
    errorPopUP: state.store.doorKey.errorPopUP
  }
}

App.propTypes = {
  bgImage: propTypes.string,
  roomAssistancePageStatus: propTypes.bool,
  serverTime: propTypes.object,
  schedules: propTypes.object,
  durations: propTypes.arrayOf(propTypes.object),
  defaultLayouts: propTypes.object,
  guestLanguages: propTypes.string,
  hotelLanguage: propTypes.object,
  durationId: propTypes.string,
  layoutText: propTypes.object
}

export default connect(
  mapStateToProps,
  {
    roomAssistanceStatusChange,
    getClientConfig,
    getServerTime,
    getWetherInfo,
    guestDetails,
    guestLanguage,
    getHotelLanguages,
    updateCurrentLayout,
    updateDurationLang,
    updateDefaultLanguage,
    setFaceData,
    fetchFaceBasedJson,
    fetchActivities,
    DefaultFaceData,
    facebookProfile,
    setNavItem,
    fetchSissonToken,
    setLauncherWidget,
    setRegPage,
    allColors,
    firstOnHome,
    setTVtype,
    HealthService,
    setPreloadScreen,
    popupOpenClose,
    setDoorKeyNotificaionPage
  }
)(App);